var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('componente-ecac',{model:{value:(this.value),callback:function ($$v) {_vm.$set(this, "value", $$v)},expression:"this.value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }